import { AnalyticsEventType, Commerce } from '@/services/analytics/platforms/adobe-analytics/models';
import { RemoveFromBagEvent } from '@/services/analytics/events';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { ServicesContainer } from '@/services';
import { AdobeBaseEvent } from './adobe-base-event';
import { ProductListItem } from '../classes/product-list-item';

export class AdobeCartRemoveEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.RemoveFromBag;
  commerce = { ... this.commerce, productListRemovals: { value: 1 } } as Commerce;

  constructor(event: RemoveFromBagEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    if (event.meal) {
      this.productListItems = ProductListItem.getProductListItems(event.meal, store, services.order.isDelivery());
    }
  }
}
